import { sendAdminRequest, sendRequest } from '../api/websocketApi';
import useStore from '../store/store';

interface APIResponse {
    success: boolean;
    errCode: string;
    url: string;
}

const GetFileURL = (
    filePath: string,
    isAdmin = false
): Promise<string | null> => {
    const { setLoading, setFormError } = useStore.getState();

    return new Promise((resolve) => {
        setLoading(true);
        if (isAdmin) {
            sendAdminRequest(
                {
                    endpoint: '/file/get-url',
                    body: { filePath },
                },
                (data: APIResponse) => {
                    const { success, errCode, url } = data;
                    setLoading(false);
                    if (success) {
                        resolve(url);
                    } else {
                        if (errCode) setFormError(errCode);
                        resolve(null);
                    }
                }
            );
        } else {
            sendRequest(
                {
                    endpoint: '/file/get-url',
                    body: { filePath },
                },
                (data: APIResponse) => {
                    const { success, errCode, url } = data;
                    setLoading(false);
                    if (success) {
                        resolve(url);
                    } else {
                        if (errCode) setFormError(errCode);
                        resolve(null);
                    }
                }
            );
        }
    });
};

export default GetFileURL;
